// Stato del banner di validazione. Gli errori arrivano dal backend (al
// caricamento e dopo ogni salvataggio) o dalla validazione lato client che
// blocca il salvataggio: appena il grafo cambia rispetto a quello validato sono
// riferiti a un canvas che non esiste piu', quindi vanno declassati invece che riproposti.

/**
 * `stale`: il grafo e' cambiato dopo la validazione che ha prodotto gli errori.
 * @returns {{kind:'none'|'errors'|'warnings'|'stale', graphMessages:string[], count:number}}
 *  - `errors`:   errori dell'ultima validazione, ancora attuali
 *  - `warnings`: nessun errore, solo segnalazioni: il flusso e' valido e
 *                salvabile, ma una scelta e' probabilmente involontaria
 *  - `stale`:    c'e' qualcosa da segnalare ma il grafo e' cambiato dopo la validazione
 *
 * `graphMessages` sono i messaggi da stampare per esteso nel banner: per gli
 * errori solo quelli di grafo (quelli di nodo sono gia' marcati sul canvas),
 * per i warning tutti, perche' sono pochi e il badge giallo da' solo l'icona.
 */
export function flowValidationBanner({ validationErrors = [], stale = false } = {}) {
  const count = validationErrors.length;
  if (count === 0) return { kind: 'none', graphMessages: [], count: 0 };
  if (stale) return { kind: 'stale', graphMessages: [], count };

  const errors = validationErrors.filter(e => e.severity !== 'warning');
  if (errors.length === 0) {
    return {
      kind: 'warnings',
      graphMessages: validationErrors.map(e => e.message),
      count,
    };
  }
  return {
    kind: 'errors',
    graphMessages: errors.filter(e => !e.nodeId).map(e => e.message),
    count: errors.length,
  };
}

/** Toglie i marker di errore dai nodi, restituendo la lista originale se non ce n'erano. */
export function clearNodeValidationErrors(nodes = []) {
  if (!nodes.some(n => n.data?.__validationError)) return nodes;
  return nodes.map(n => (
    n.data?.__validationError ? { ...n, data: { ...n.data, __validationError: null } } : n
  ));
}
